import styled, { css } from 'styled-components';

const WrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 70%;
  overflow: hidden;
  /* 
  this is used for tenant detail 
  in tentant deatil log sidebar is hidden 
  so this wrapper can take full width instead of 70%
  */
  ${(props) =>
    props.fullWidth &&
    css`
      flex: 0 1 100%;
    `}
`;

export default WrapperStyled;
